import { Box, useMediaQuery, useTheme } from "@mui/material";
import PivotReportDataProvider from "./PivotReportDataProvider";
import PivotReportHeader from "./PivotReportHeader";
import PivotReportProvider from "./PivotReportProvider";
import PivotHeatMap from "./components/PivotHeatMap";
import PivotReportFilter from "./components/PivotReportFilter";

export interface PivotReportProps {}

const PivotReport: React.FC<PivotReportProps> = ({}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <PivotReportDataProvider>
      <PivotReportHeader />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          ml: isMobile ? -3 : 0,
          mr: isMobile ? -3 : 0,
          "& .MuiPaper-root": {
            borderRadius: isMobile ? 0 : undefined,
          },
        }}
      >
        <PivotReportProvider>
          <PivotReportFilter />
          <PivotHeatMap />
        </PivotReportProvider>
      </Box>
    </PivotReportDataProvider>
  );
};
export default PivotReport;
